import { Link, type LinkProps } from 'react-router-dom'
import { cn } from '@/lib/utils'

/**
 * The one look for a text link (D124): the text's own colour, underlined,
 * dimming on hover. Use `textLinkClass` for a button that reads as a link.
 */
export const textLinkClass =
  'font-medium underline underline-offset-4 transition-colors hover:text-muted-foreground'

export function TextLink({ className, ...props }: LinkProps) {
  return <Link className={cn(textLinkClass, className)} {...props} />
}
